@if (attachForm) {
  <div [formGroup]="attachForm">
    <div class="flex flex-column gap-1">
      <div class="flex flex-row align-items-center" [style]="{'width': '31rem'}">
        <label for="form_nominal" class="w-10rem justify-content-start">
          {{ "investment.label.amount" | translate }} / {{ "investment.label.currency" | translate }}
        </label>
        <div class="relative w-21rem">
          <p-input-group>
            <input [tabindex]="1" class="text-right" (blur)="notifyParent()" pInputText appAmountInput id="form_nominal"
                   formControlName="nominal"
                   [style]="{width: '100%'}"/>
            <p-select [tabindex]="2" class="w-10rem" [options]="availableCurrencies" formControlName="currency"
                      id="form_currency" appendTo="body" optionLabel="code"/>
          </p-input-group>

          @if (attachForm.get('nominal')?.hasError('amountIsLessMin')) {
            <p-message severity="error" variant="simple" size="small">
              {{ 'investment.label.validator.minAmount' | translate: {minAmount: attachForm.get('nominal')?.getError('amountIsLessMin') | stringDEFromNumber} }}
            </p-message>
          }
          @if (attachForm.get('nominal')?.hasError('amountIsGreaterMax')) {
            <p-message severity="error" variant="simple" size="small">
              {{ 'investment.label.validator.maxAmount' | translate: {maxAmount: attachForm.get('nominal')?.getError('amountIsGreaterMax') | stringDEFromNumber} }}
            </p-message>
          }
        </div>
      </div>

      @if (renderAenderungsFeld) {
        <div class="flex flex-row align-items-center" [style]="{'width': '31rem'}">
          <label for="form_change" class="justify-content-start w-10rem">
            {{ "investment.label.change" | translate }}
          </label>
          <p-input-group no-border-radius class="w-21rem">
            <p-select [tabindex]="3" [options]="availableChangeOptions()" optionLabel="label" optionValue="value"
                      [style]="{ 'width': '100%' }" formControlName="change" appendTo="body" id="form_change">
            </p-select>
          </p-input-group>
        </div>
      }
      @if (renderAufloesenButton) {
        <div class="flex flex-row align-items-center" [style]="{'width': '31rem'}">
          <label for="aufloesenButtonId" class="w-10rem justify-content-start">
            {{ "investment.label.aktion" | translate }}
          </label>
          <p-input-group no-border-radius class="w-21rem">
            <p-button [tabindex]="4" class="w-21rem" [style]="{'width': '100%'}" (onClick)="closeCallMoney()"
                      [disabled]="!reducable()"
                      severity="secondary" icon="pi pi-caret-right"
                      label="{{ 'investment.label.aktionButton' | translate }}"
                      id="aufloesenButtonId"/>
          </p-input-group>
          <p-confirm-dialog/>
        </div>
      }
    </div>
  </div>
}
